import dashboardPartnerData from '@/mixins/dashboardPartnerData.js';

export default {
  mixins: [dashboardPartnerData],
  computed: {
    currentMutation() {
      return this.partnerData?.mutations
        ? this.partnerData.mutations.find(item => item.language === this.$auth.user.language) ?? {}
        : {};
    }
  }
};
